import React from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

import blokResolvers from './blokResolvers';
import markResolvers from './markupResolvers';
import nodeResolvers from './nodeResolvers';
import classNames from 'classnames';
import { Box } from '../Box/Box';
import { RichtextStoryblok } from '../../types/storyblok';

type MarkupProps = {
  content: RichtextStoryblok | undefined;
  className?: string;
};

const Markup = ({ content, className }: MarkupProps) => {
  if (!content) return null;

  return (
    <Box as="div" className={classNames(className)}>
      {render(content, {
        markResolvers,
        nodeResolvers,
        blokResolvers: {
          ...Object.entries(blokResolvers).reduce((acc, [name, Component]) => {
            const MarkupComponent = (props) => (
              <Component
                {...props}
                className={
                  (classNames(`markup-${name}`.trim()),
                  'overlayOverBkg',
                  className)
                }
              />
            );

            acc[name] = MarkupComponent;

            return acc;
          }, {}),
        },
      })}
    </Box>
  );
};

export default Markup;
